import api from "./api";
import {
  ApiResponse,
  Proje,
  ProjeCreateDTO,
  ProjeFoto,
  ProjeFotoCreateDTO,
  ProjeUpdateDTO,
} from "./types";

export const ProjelerService = {
  listele: async () => {
    const response = await api.get<ApiResponse<Proje[]>>(
      "/api/Projeler/Listele"
    );
    return response.data;
  },

  detay: async (id: string) => {
    const response = await api.get<ApiResponse<Proje>>(
      `/api/Projeler/Detay/${id}`
    );
    return response.data;
  },

  ekle: async (data: ProjeCreateDTO) => {
    const formData = new FormData();
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("projeYer", data.projeYer);
    formData.append("projeYil", data.projeYil);
    formData.append("projeIsbirlik", data.projeIsbirlik);
    formData.append("projeEkip", data.projeEkip);
    formData.append("insaatAlan", data.insaatAlan);
    if (data.temaTipId) {
      formData.append("temaTipId", data.temaTipId);
    }
    if (data.kapakFotoFile) {
      formData.append("kapakFotoFile", data.kapakFotoFile);
    }
    if (data.yatayFotoFile) {
      formData.append("yatayFotoFile", data.yatayFotoFile);
    }

    const response = await api.post<ApiResponse<Proje>>(
      "/api/Projeler/Ekle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  guncelle: async (data: ProjeUpdateDTO) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("projeYer", data.projeYer);
    formData.append("projeYil", data.projeYil);
    formData.append("projeIsbirlik", data.projeIsbirlik);
    formData.append("projeEkip", data.projeEkip);
    formData.append("insaatAlan", data.insaatAlan);
    formData.append("kapakGorsel", data.kapakGorsel || ""); // kontrol et
    formData.append("yatayGorsel", data.yatayGorsel || ""); // kontrol et
    if (data.temaTipId) {
      formData.append("temaTipId", data.temaTipId);
    }
    if (data.kapakFotoFile) {
      formData.append("kapakFotoFile", data.kapakFotoFile);
    }
    if (data.yatayFotoFile) {
      formData.append("yatayFotoFile", data.yatayFotoFile);
    }

    const response = await api.put<ApiResponse<Proje>>(
      "/api/Projeler/Guncelle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  sil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Projeler/Sil/${id}`
    );
    return response.data;
  },

  projeFotolariGetir: async () => {
    const response = await api.get<ApiResponse<ProjeFoto[]>>(
      "/api/Projeler/ProjeFotolari/Getir"
    );
    return response.data;
  },

  projeFotolariDetay: async (projeId: string) => {
    const response = await api.get<ApiResponse<ProjeFoto[]>>(
      `/api/Projeler/ProjeFotolari/Detay/${projeId}`
    );
    return response.data;
  },

  projeFotoEkle: async (data: ProjeFotoCreateDTO) => {
    const formData = new FormData();
    formData.append("sira", data.sira.toString());
    formData.append("projeId", data.projeId);
    formData.append("foto", data.foto);

    const response = await api.post<ApiResponse<ProjeFoto>>(
      "/api/Projeler/ProjeFotolari/Ekle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  projeFotoSil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Projeler/ProjeFotolariSil/${id}`
    );
    return response.data;
  },
};
